module.exports = __webpack_public_path__ + "static/media/ve.d6be56f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ve.svg
// module id = 283
// module chunks = 0